'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiHtml5 = function TiHtml5(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.8 5.8l1.2 1.9 1.2-1.9v2.5h1.6v-5h-1.6l-1.2 1.9-1-1.9h-1.8v5h1.6z m8.9 2.5v-1.6h-2.4v-3.4h-1.6v5z m-14.4 0h1.7v-3.3h1.5v-1.7h-4.7v1.7h1.5z m-5.3-1.6h1.5v1.6h1.7v-5h-1.7v1.7h-1.5v-1.7h-1.7v5h1.7z m-2.7 3.3l2 24 9.7 2.7 9.7-2.7 2-24h-23.4z m18.9 7.7h-11.4l0.4 3h10.6l-0.8 9.1-6 1.7-6-1.7-0.5-4.8h3l0.2 2.5 3.3 0.8 3.3-0.8 0.4-3.8h-10.4l-0.8-8.9h15l-0.3 2.9z' })
        )
    );
};

exports.default = TiHtml5;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/html5.js
// module id = 3651
// module chunks = 0